export default function Services() {
  const services = [
    {
      title: 'ブランドイラストレーション',
      category: '企業ブランディング',
      description: '企業の個性と価値観を視覚化し、ブランドアイデンティティを確立するオリジナルイラストレーションを制作します。ロゴデザインから広告ビジュアルまで、一貫性のあるブランド表現をサポート。',
      price: '¥300,000〜',
      image: 'https://readdy.ai/api/search-image?query=Modern%20brand%20illustration%20design%20for%20corporate%20identity%2C%20clean%20geometric%20shapes%2C%20professional%20color%20palette%2C%20minimalist%20style%2C%20vector%20art%20aesthetic%2C%20business%20branding%20visual%2C%20contemporary%20graphic%20design%2C%20simple%20background&width=400&height=400&seq=service001&orientation=squarish',
      icon: 'ri-building-line'
    },
    {
      title: '書籍・出版イラスト',
      category: '出版・編集',
      description: '小説の挿絵、絵本、雑誌の特集記事など、文章に命を吹き込むイラストレーションを提供。読者の想像力を刺激し、物語の世界観を豊かに表現します。',
      price: '¥150,000〜',
      image: 'https://readdy.ai/api/search-image?query=Book%20illustration%20artwork%20for%20publishing%2C%20storybook%20style%2C%20narrative%20visual%20art%2C%20editorial%20illustration%2C%20literary%20scene%20depiction%2C%20artistic%20storytelling%2C%20watercolor%20texture%2C%20warm%20color%20palette%2C%20simple%20clean%20background&width=400&height=400&seq=service002&orientation=squarish',
      icon: 'ri-book-open-line'
    },
    {
      title: 'Webサイトイラスト',
      category: 'デジタルコンテンツ',
      description: 'Webサイトやアプリケーションのユーザー体験を向上させるカスタムイラストレーション。UI/UXデザインと調和し、ブランドの個性を際立たせるビジュアル要素を制作。',
      price: '¥200,000〜',
      image: 'https://readdy.ai/api/search-image?query=Website%20illustration%20for%20digital%20interface%2C%20modern%20UI%20graphics%2C%20flat%20design%20style%2C%20user%20interface%20elements%2C%20web%20design%20visual%20assets%2C%20colorful%20icons%2C%20digital%20art%20for%20applications%2C%20clean%20simple%20background&width=400&height=400&seq=service003&orientation=squarish',
      icon: 'ri-computer-line'
    },
    {
      title: '広告・キャンペーンビジュアル',
      category: 'マーケティング',
      description: 'SNS広告、ポスター、バナーなど、マーケティングキャンペーンを成功に導くインパクトのあるイラストレーション。ターゲット層の心を掴む視覚表現を実現します。',
      price: '¥250,000〜',
      image: 'https://readdy.ai/api/search-image?query=Advertising%20campaign%20illustration%2C%20marketing%20visual%20design%2C%20eye-catching%20promotional%20artwork%2C%20dynamic%20composition%2C%20bold%20colors%2C%20commercial%20illustration%20style%2C%20attention-grabbing%20graphics%2C%20simple%20background&width=400&height=400&seq=service004&orientation=squarish',
      icon: 'ri-megaphone-line'
    },
    {
      title: 'キャラクターデザイン',
      category: 'オリジナルキャラクター',
      description: '企業マスコット、ゲームキャラクター、教育コンテンツ用キャラクターなど、目的に応じたオリジナルキャラクターをデザイン。愛されるキャラクターで、ブランドの親しみやすさを向上。',
      price: '¥180,000〜',
      image: 'https://readdy.ai/api/search-image?query=Original%20character%20design%20illustration%2C%20cute%20mascot%20character%2C%20friendly%20personality%2C%20expressive%20features%2C%20professional%20character%20art%2C%20animation%20style%2C%20vibrant%20colors%2C%20simple%20clean%20background&width=400&height=400&seq=service005&orientation=squarish',
      icon: 'ri-user-smile-line'
    },
    {
      title: 'パッケージイラスト',
      category: '商品パッケージ',
      description: '商品の魅力を最大限に引き出すパッケージデザイン用イラストレーション。店頭で目を引き、購買意欲を高める視覚表現で、商品の価値を伝えます。',
      price: '¥220,000〜',
      image: 'https://readdy.ai/api/search-image?query=Product%20packaging%20illustration%20design%2C%20decorative%20pattern%20artwork%2C%20elegant%20label%20graphics%2C%20commercial%20package%20visual%2C%20artistic%20product%20design%2C%20refined%20aesthetic%2C%20beautiful%20color%20scheme%2C%20simple%20background&width=400&height=400&seq=service006&orientation=squarish',
      icon: 'ri-gift-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-12">
          <div className="max-w-2xl">
            <h2 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              提供する<span className="text-rose-600">サービス</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              多様な業界・用途に対応した、プロフェッショナルなイラストレーションサービスを提供しています。<br />
              お客様のニーズに合わせて、最適な表現方法をご提案いたします。
            </p>
          </div>
          <div className="px-6 py-2 bg-gray-900 text-white text-sm font-medium rounded-full whitespace-nowrap">
            全6カテゴリー
          </div>
        </div>

        <div className="overflow-x-auto pb-4 -mx-8 px-8">
          <div className="flex gap-6 min-w-max">
            {services.map((service, index) => (
              <div 
                key={index}
                className="w-80 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 flex-shrink-0 cursor-pointer"
              >
                <div className="p-6">
                  <div className="w-full h-64 mb-6 rounded-xl overflow-hidden bg-gray-100">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <p className="text-xs text-gray-500 mb-1">{service.category}</p>
                      <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                        {service.title}
                      </h3>
                    </div>
                    <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 ml-4">
                      <i className={`${service.icon} text-2xl text-rose-600`}></i>
                    </div>
                  </div>
                  
                  <p className="text-sm text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>
                  
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className="text-2xl font-bold text-gray-900">{service.price}</span>
                    <span className="text-xs text-gray-500">参考価格</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}